let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h5BdS")).then(() => parcelRequire('fqEd0'));